import { defineComponent } from '@vue/composition-api'
import Header from './components/header'
import Content from './components/content'
import NotSupport from './components/status/not-support'
import styles from './index.module.scss'
import { os } from 'yunxi-helper'
import IsoNotSafari from './components/status/iso-not-safari'

const ua = navigator.userAgent

// iPadOS 13+ 默认「请求桌面网站」时，Safari 的 UA 会伪装成 Mac（不含 iPad），
// 用触摸点数区分真 Mac 和 iPad（Mac 没有触摸屏，maxTouchPoints 为 0）。
const isIPad =
  /iPad/.test(ua) || (/Macintosh/.test(ua) && navigator.maxTouchPoints > 1)
// 是否为 iOS 设备（iPhone / iPod / iPad，含 iPad 桌面模式）
const isIOS = /iPhone|iPod/.test(ua) || isIPad

// 判断是否为 Safari（含 iOS 与 macOS）：iOS 上所有浏览器都基于 WebKit，
// 用「反向排除已知的非 Safari 浏览器/内嵌 WebView」比依赖 UA 中是否含
// `Version/` 的脆弱正则更可靠；Chromium/Edge 等都含 Chrome 标识也会被排除。
const isSafari = (() => {
  const nonSafari = /(Chrome|Chromium|CriOS|FxiOS|Firefox|EdgiOS|Edg|OPiOS|OPR|Opera|mercury|UCBrowser|QQBrowser|MQQBrowser|Quark|baidu|MicroMessenger|DingTalk|Lark|Line|FBAN|FBAV|Instagram)/i
  // 真正的 Safari 含 "Safari" 标识，且不含上述其它浏览器/App 内嵌 WebView 的标识
  return /Safari/i.test(ua) && !nonSafari.test(ua)
})()

// import VConsole from 'vconsole'

// const vConsole = new VConsole()

export default defineComponent({
  setup() {
    return () => (
      <div class={styles.room}>
        <Header />
        <div class={styles.maxWidth}>
          {(() => {
            // iOS（含 iPad、含 iPad 桌面模式）优先判断：必须是 Safari
            if (isIOS) {
              if (!isSafari) {
                return <IsoNotSafari />
              }
              return <Content />
            }
            // 真正的桌面端：支持 Chrome 或 Safari
            if (os.isPc) {
              if (!os.isChrome && !isSafari) {
                return <NotSupport />
              }
            }

            return <Content />
          })()}
        </div>
      </div>
    )
  }
})
